import React from 'react';
import { Container, Stack } from '@fiverr-private/layout_components';
import { theme } from '@fiverr-private/theme';
import { ClockIcon } from '@fiverr-private/visuals';
import { Text } from '@fiverr-private/typography';
import { useResellingProgramsContext } from '../../context';
import { appTranslate } from '../../i18n';

export const DiscountBanner = () => {
    const {
        resellingPrograms: { discountPercent },
    } = useResellingProgramsContext();

    if (!discountPercent) {
        return null;
    }

    return (
        <Container flex="1" maxWidth={theme.numericBreakpoints.xl} width="100%">
            <Stack
                justifyContent="center"
                alignItems="center"
                wrap="wrap"
                backgroundColor="green_100"
                borderRadius="lg"
                paddingY="4"
                paddingX="2"
            >
                <Stack alignItems="center">
                    <ClockIcon size="sm" />
                    <Text fontWeight="semibold">{appTranslate('discount_banner.title')}</Text>
                </Stack>

                <Text>
                    {appTranslate('discount_banner.description', {
                        params: {
                            discount: discountPercent,
                        },
                    })}
                </Text>
            </Stack>
        </Container>
    );
};
